import { forwardRef } from "react";
import { Text } from "../../../../packages/ui-kit";
import type { MessageService } from "../../types";
import styles from "./message-kinds.module.scss";

type Props = {
  message: MessageService;
};

export const ServiceMessageInfo = forwardRef<HTMLDivElement, Props>(
  ({ message }, forwardedRef) => (
    <div ref={forwardedRef} className={styles["message-service"]}>
      <Text size="small" data-test-id="service-message">
        {message.content.text}
      </Text>
    </div>
  )
);
